import BluePlainTheme from './blue.plain.theme';

export default BluePlainTheme;
